<div
  class="innerBanner"
  [style.background-image]="'url(' + blogBannerContent.bannerImage + ')'"
  (click)="imageClick(0)"
>
  <!-- inner banner-->
  <!-- <div class="bannerText">
    <h1>{{ 'HIGHLIGHTS' | translate }}</h1>
  </div> -->
</div>

<p-galleria
  [(value)]="images"
  [(visible)]="displayCustom"
  [(activeIndex)]="activeIndex"
  [fullScreen]="true"
  [showItemNavigators]="false"
  [baseZIndex]="100000"
  [containerStyle]="{ 'max-width': '90%' }"
>
  <ng-template pTemplate="item" let-item>
    <img [src]="item" class="gallery-image" />
  </ng-template>
</p-galleria>

<!-- <img class="innerBanner" [src]="blogBannerContent.bannerImage" style="cursor: pointer" (click)="imageClick(0)" /> -->

<div class="container contentPanel">
  <nav aria-label="breadcrumb">
    <ol class="breadcrumb">
      <li class="breadcrumb-item">
        <a href="/home">{{ 'Home' | translate }}</a>
      </li>
      <li class="breadcrumb-item active" aria-current="page">{{ 'Blogs' | translate }}</li>
    </ol>
  </nav>
  <h1>{{ blogBannerContent.bannerTitle }}</h1>
  <p [innerHTML]="blogBannerContent.content"></p>
  <p>&nbsp;</p>

  <div class="p-autocomplete-container autoCompleteStyle">
    <p-autoComplete
      [(ngModel)]="selectedItem"
      [suggestions]="suggestions"
      (onSelect)="onSelectBlogTitle($event)"
      (completeMethod)="searchHighlights($event)"
      [minLength]="3"
      [delay]="300"
      [field]="'title'"
      styleClass="w-full"
      [placeholder]="'Search for a blog article' | translate"
    >
      <ng-template let-item pTemplate="item">
        <div class="p-d-flex p-ai-center">
          <span>{{ item.title }}</span>
        </div>
      </ng-template>
    </p-autoComplete>
    <i *ngIf="selectedItem" class="pi pi-times clear-icon" (click)="clear()"></i>
  </div>

  <div class="p-grid mb-2">
    <div class="p-lg-2">
      <div>
        <span style="color: red"> {{ resultsFound }}&nbsp;</span>{{ 'Results were found' | translate }}
      </div>
    </div>
    <span class="filterMobile noDesktop" (click)="searchToggle()">
      <a href="javascript:;" class="filterBtn"><i class="icon icon-sliders"></i> {{ 'Filters' | translate }}</a>
    </span>
    <div class="p-lg-9 highlightsFilterSection searchToggle" id="SearchToggle">
      <h2 class="closeFilter"><i class="icon icon-sliders"></i> {{ 'Filter Results' | translate }}</h2>
      <div class="closeFilter" (click)="searchToggle()">X</div>

      <!-- <p-selectButton
        [options]="specialInterestItems"
        (onChange)="filterData(selectedSpecialInterest)"
        [(ngModel)]="selectedSpecialInterest"
        multiple="multiple"
      >
        <ng-template let-item>
          <div style="border: none">
            <i class="{{ item.icon }}"></i>
            <span>{{ item.name | translate }}</span>
          </div>
        </ng-template>
      </p-selectButton> -->
      <div class="dropdown">
        <button class="dropdown-button">{{ 'Select category' | translate }}</button>
        <div class="dropdown-content">
          <div *ngFor="let item of specialInterestItems" class="border-bottom">
            <span (click)="toggleSelection(item)" [ngStyle]="{ color: item.selected ? '#00a7a6' : '#000' }">
              <i class="{{ item.icon }}"></i> {{ item.name | translate }}
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="p-lg-1 sortBy text-right">
      <select id="sort-by" aria-label="Sort By" placeholder="Sort By" (change)="sort($event.target.value)">
        <option value="" disabled hidden>{{ 'Sort By' | translate }}</option>
        <option translate value="popularity">{{ 'Popular ' | translate }}</option>
        <option translate value="A to Z">{{ 'A to Z' | translate }}</option>
        <option translate value="Z to A">{{ 'Z to A' | translate }}</option>
        <option translate selected value="newest">{{ 'Newest' | translate }}</option>
        <option translate value="oldest">{{ 'Oldest' | translate }}</option>
      </select>
    </div>
  </div>

  <div *ngIf="highlightsProducts" class="p-grid m-0" style="cursor: pointer" #productsList>
    <div
      *ngFor="let highlight of highlightsProducts; let index = index"
      class="p-lg-3 p-md-6 highlightSection"
      key="index"
    >
      <div class="himage-wrapper">
        <a target="_blank" [href]="getHighlightUrl(highlight)">
          <img class="himage" [src]="highlight.uri" alt="{{ highlight.title }}" />
        </a>
        <div class="title" *ngIf="highlight.specialInterestName">
          <i class="{{ highlight.specialIntersetIcon }}"></i>
          <small style="font-size: 0.875em; font-weight: 400">{{
            highlight.specialInterestName | translate | uppercase
          }}</small>
        </div>
      </div>
      <p class="mb-3 ml-2 mt-1">
        <a
          target="_blank"
          [href]="getHighlightUrl(highlight)"
          style="cursor: pointer; text-decoration: none; color: #399"
        >
          {{ highlight.title }}
        </a>
      </p>
    </div>
  </div>
  <div class="row mt-10" *ngIf="isViewMoreRecords">
    <div class="col-md-12 text-center mb-2">
      <button type="button" class="btn btn-primary btn-lg" (click)="ViewMoreBlogs()">
        {{ 'View More' | translate }} <i class="glyphicon glyphicon-plus"></i>
      </button>
    </div>
  </div>
</div>

<p-toast key="viewMoreInfo" position="top-center" [baseZIndex]="15000"></p-toast>
